export const queryKeys = {
  base: ['e911'] as const,
  listAddresses: () => [...queryKeys.base, 'e911-addresses'],
};
